import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { Modal } from '@els/els-react--modal';

function ConfirmationPopup({
  onConfirm = () => {},
  onClose = () => {},
  onRegister = () => {},
  submitButtonText = 'Yes',
  submitButtonType = 'primary',
  submitButtonClassName = '',
  dismissButtonText = 'Cancel',
  actionButtonSize = 'small',
  isCancelButton = true,
  title,
  text,
  registerText,
}) {
  // Drive initial focus through the Modal's own focus trap; a manual .focus()
  // loses the race against focus-trap's delayed initialFocus. Modal also handles
  // Escape-to-close and focus return to the opener natively.
  const firstButtonRef = React.useRef(null);

  return (
    <Modal
      id="history-confirmation-modal"
      className="history-confirmation-popup"
      label={title}
      shouldHideCloseButton
      focusTrapProps={{ focusTrapOptions: { initialFocus: () => firstButtonRef.current } }}
      onClose={onClose}>
      <div>
        <header className="history-confirmation-popup__header">
          <h3 className="history-confirmation-popup__title">{title}</h3>
          <ButtonWithIcon
            data-e2e="e2e-confirmation-modal-close"
            type="link"
            sprite="Close"
            size="small"
            iconOnly
            className="history-confirmation-popup__close-button"
            aria-label="Close"
            onClick={onClose}>
            Close Modal
          </ButtonWithIcon>
        </header>
        <section className="u-els-padding-bottom-1x1o2">{text}</section>
        <footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {isCancelButton && (
            <Button
              data-e2e="e2e-confirmation-modal-cancel"
              type="secondary"
              size={actionButtonSize}
              iconRight
              className="e2e-confirmation-modal-cancel"
              name="cancel"
              aria-label={dismissButtonText || 'Cancel'}
              ref={firstButtonRef}
              onClick={onClose}>
              {dismissButtonText}
            </Button>
          )}
          <Button
            data-e2e="e2e-confirmation-modal-submit"
            type={submitButtonType}
            size={actionButtonSize}
            iconRight
            className={`e2e-confirmation-modal-submit u-els-margin-left ${submitButtonClassName}`.trim()}
            name="confirm"
            aria-label={submitButtonText || 'Yes'}
            ref={isCancelButton ? undefined : firstButtonRef}
            onClick={onConfirm}>
            {submitButtonText}
          </Button>
          {registerText && (
            <Button
              data-e2e="e2e-confirmation-modal-register"
              type="primary"
              size={actionButtonSize}
              iconRight
              className="e2e-confirmation-modal-register"
              name="register"
              aria-label={registerText}
              onClick={onRegister}>
              {registerText}
            </Button>
          )}
        </footer>
      </div>
    </Modal>
  );
}

ConfirmationPopup.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  submitButtonType: PropTypes.string,
  submitButtonClassName: PropTypes.string,
  dismissButtonText: PropTypes.string,
  actionButtonSize: PropTypes.string,
  registerText: PropTypes.string,
  isCancelButton: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  onRegister: PropTypes.func,
};

export default ConfirmationPopup;
